import { useSelector } from "react-redux";

const useScreenSize = () => {
    return useSelector((state) => state?.ui?.screenSize || {isDesktop: true});
};

export default useScreenSize;
